<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="w-100 position-relative">
        <div class="col-12 pl-md-5 ml-auto list-header">

            <h1 class="list-header-title">
                {{'Determinants / Registrations' | translate}}
                <span (click)="switchHeadings()"
                      class="addBtn services-icon--add ml-2"
                      style="position:relative;top:-5px;">Turn Table</span>
            </h1>
        </div>
        <div class="col-12 pl-5">
            <div class="row">
                <div class="col-md-12">
                    <section class="table-container cross-table-container">
                        <section class="table-flip-scroll">
                            <table class="table table-bordered table-striped cross-table">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th *ngFor="let item of determinantRegistrationRelations[0]; let i = index; ">
                                            <span *ngIf="!tableSwitched"
                                                  class="limited">
                                                {{ determinantRegistrationRelations[0][i].registrationShortName && determinantRegistrationRelations[0][i].registrationShortName !== "" ? determinantRegistrationRelations[0][i].registrationShortName : determinantRegistrationRelations[0][i].registrationName }}
                                            </span>
                                            <span *ngIf="tableSwitched && determinantRegistrationRelations[0][i].relationshipType?.valueOf() == 'MANDATORY'"
                                                  class="limited">
                                                {{ 'general.mandatory' | translate }}
                                            </span>
                                            <span *ngIf="tableSwitched && determinantRegistrationRelations[0][i].relationshipType?.valueOf() == 'OPTIONAL'"
                                                  class="limited">
                                                {{ 'general.optionnal' | translate }}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of determinantRegistrationRelations; let i = index;">
                                        <td>
                                            <span class="badge badge-success"
                                                  *ngIf="!tableSwitched && row[0].relationshipType?.valueOf() == 'MANDATORY'">{{ 'general.mandatory' | translate }}</span>
                                            <span class="badge badge-warning"
                                                  *ngIf="!tableSwitched && row[0].relationshipType?.valueOf() == 'OPTIONAL'">{{'general.optionnal' | translate }}</span>
                                            <span *ngIf="tableSwitched"
                                                  class="badge badge-warning">
                                                {{ row[0].registrationName}}
                                            </span>
                                        </td>
                                        <td class="cursor-hand"
                                            (click)="editDeterminant(determinantRegistrationRelations[i][j])"
                                            *ngFor="let col of row; let j = index;">

                                            <span *ngIf="determinantRegistrationRelations[i][j]?.determinantGroupName">{{determinantRegistrationRelations[i][j]?.determinantGroupName}}</span>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </section>
                        <modal-placeholder></modal-placeholder>
                        <span class="hidden"
                              #trans_mandatory>{{ 'general.mandatory' | translate }}</span>
                        <span class="hidden"
                              #trans_optional>{{ 'general.optionnal' | translate }}</span>
                    </section>
                </div>
            </div>
        </div>

        <div *ngIf="showModal"
             class="row layer half-layer px-3">
            <layer-header (closeLayer)="onCancel()"
                          [listIcons]=false
                          [title]="'Edit determinant'">
            </layer-header>
            <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                             class="row layer sub-layer px-3 pt-1"
                             [serviceId]="selectedDeterminantRegistrationRelations.serviceId"
                             [determinant]="store.state.common.determinantSection.determinant"
                             (formSubmit)="closeEdit()"
                             (editCancel)="closeEdit()"></determinant-new>
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <determinant-builder-new [serviceId]="selectedDeterminantRegistrationRelations.serviceId"
                                                 [jsonString]="selectedDeterminantRegistrationRelations.jsonDeterminants"
                                                 (onSave)="onOk()"
                                                 (onCancel)="onCancel()"
                                                 (onChange)="selectedDeterminantRegistrationRelations.jsonDeterminants = $event.jsonString"
                                                 class="col-12">
                        </determinant-builder-new>
                    </div>
                </div>
            </div>
        </div>
        <div class="shadow"></div>
    </div>
</app-service-detail>
